import React from "react";
import { useSelector } from "react-redux";
import { Skeleton, Tooltip } from "antd";
import {
  getPaneIndex,
  getWindowLocationPath,
  simpleKFormatterOnly,
} from "../../../../redux/constants";

const InfoCard = () => {
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const panes = useSelector((state) => state.Tab1.panes); //all tabs data
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const screen = useSelector((state) => state?.Screens?.screen);
  let pathName = getWindowLocationPath()?.toLowerCase();

  let index = getPaneIndex(panes, activeKey);
  const infoBarData =
    pathName === "CommandCenter"?.toLowerCase()
      ? screen?.deep_dive?.infoBar?.result?.info_bar
      : shareTemplateData
      ? shareTemplateData?.deep_dive?.infoBar?.result?.info_bar
      : panes[index]?.deep_dive?.infoBar?.result?.info_bar;

  let idsList = ["2", "3"];
  let data_map = [];
  infoBarData &&
    idsList?.forEach((e) => {
      data_map.push(
        infoBarData.filter((e1) => {
          return e1.id === e;
        })[0]
      );
    });
  return data_map?.length > 0 ? (
    data_map?.map((el, i) => {
      return (
        <div className="bg__white border border-radius-4 p-15 mb-sm-3 mr-md-3 w-100">
          <div className="portlet__title font-size14 font-weight500 mb-1 d-flex align-items-center ">
            {el?.title}
            {el?.id == 2 && el?.info_text && (
              <Tooltip
                title={el?.info_text || ""}
                placement="top"
                className="text-ellipsis d-inline-block wm-chart-card-title"
              >
                <i
                  className={`fa fa-info-circle cursor-pointer ml-1 ${
                    window.location.pathname
                      .toLowerCase()
                      ?.includes("/commandcenter/screens")
                      ? "dynamic_icon_color"
                      : "text-gray"
                  }`}
                />
              </Tooltip>
            )}
          </div>
          <div className="portlet__content fontSize-21 font-weight600">
            <Tooltip
              title={
                el?.id === "6"
                  ? el?.count?.specific?.toLocaleString()
                  : el?.count?.toLocaleString()
              }
            >
              {el?.id === "6"
                ? simpleKFormatterOnly(el?.count?.specific, true)
                : simpleKFormatterOnly(el?.count, true)}
            </Tooltip>
          </div>
        </div>
      );
    })
  ) : (
    <>
      <span className="bg__white border border-radius-4 p-15 mb-sm-3 mr-md-3 w-100">
        <Skeleton active size="small" paragraph={{ rows: 1 }} />
      </span>
      <span className="bg__white border border-radius-4 p-15 mb-sm-3 mr-md-3 w-100">
        <Skeleton active size="small" paragraph={{ rows: 1 }} />
      </span>
    </>
  );
};

export default InfoCard;
